import React, { Component } from 'react';

import CookieNoticeLink from './CookieNoticeLink';

class CookieNoticeToolbar extends Component {
  componentDidMount() {
    const { onOpenToolbar } = this.props;

    if (typeof onOpenToolbar === 'function') onOpenToolbar();
  }

  componentWillUnmount() {
    const { onCloseToolbar } = this.props;

    if (typeof onCloseToolbar === 'function') onCloseToolbar();
  }

  render() {
    const {
      onAccept,
      onReject,
      onOpenModal,
      toolbarText,
      lczStrings,
      infoUrl,
      infoTarget,
      themes: {
        bannerTheme,
        buttonTheme,
      },
      disabledLinks,
    } = this.props;

    const themeClass = bannerTheme ? ` _${bannerTheme}` : '';
    let cookieNoticeToolbarClasses = `cookie-toolbar _${bannerTheme ? 'light' : 'dark'}${themeClass}`;

    cookieNoticeToolbarClasses += buttonTheme ? ` _${buttonTheme}` : '';

    return (
      <div
        id="cookie-notice-toolbar"
        className={cookieNoticeToolbarClasses}
      >
        <div className="cookie-toolbar__wrap">
          <p className="cookie-toolbar__text">
            {toolbarText === undefined
              ? lczStrings.toolbar_text
              : toolbarText}
            {' '}
            <CookieNoticeLink
              href={infoUrl}
              className="cookie-toolbar__link"
              target={infoTarget}
              disabled={disabledLinks}
              text={lczStrings['toolbar_read-about-cookies-link']}
            />
          </p>
          <div className="cookie-toolbar__buttons">
            <button
              onClick={onOpenModal}
              className="cookie-toolbar__btn cookie-toolbar__btn_settings"
            >
              {lczStrings['toolbar_cookie-settings-btn']}
            </button>
            <div className="cookie-toolbar__btn_group">
              <button
                onClick={onReject}
                className="cookie-toolbar__btn cookie-toolbar__btn_accept"
              >
                {lczStrings['toolbar_reject-btn']}
              </button>
              <button
                onClick={onAccept}
                className="cookie-toolbar__btn cookie-toolbar__btn_accept"
              >
                {lczStrings['toolbar_accept-btn']}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CookieNoticeToolbar.defaultProps = {
  onAccept: null,
  onReject: null,
  onOpenModal: null,
  themes: {
    bannerTheme: '',
    buttonTheme: '',
  },
};

export default CookieNoticeToolbar;
